module.exports = __webpack_public_path__ + "static/media/sprintbot4.cfde8442.png";